// @flow
import * as React from 'react';
import { HeaderElements } from "../../HeaderElements/HeaderElements";
export var Agb = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center gridreplace infopage l-container h-center c-infopage"
  }, /*#__PURE__*/React.createElement(HeaderElements, {
    title: "AGB",
    description: ""
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: window.legal.terms
    }
  }));
};
export default Agb;